import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ssdt_icon",
  "use": "icon-ssdt_icon-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-ssdt_icon\">\n<title>2</title>\n<path d=\"M28.8 25.6v3.2h-16v-3.2h16zM14.826 1.967l13.529 13.624-9.008 9.008-5.657-5.657-9.050 9.051-2.263-2.263 9.051-9.051-5.657-5.657 9.055-9.055zM14.816 6.5l-4.521 4.521 9.051 9.051 4.489-4.489-9.019-9.083z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol